import client from "./client";

const timetableApi = {
  get(params = {}) {
    return client.get("/timetable", { params }).then((r) => r.data);
  },

  getForClass(className) {
    return client.get("/timetable", { params: { class: className } }).then((r) => r.data);
  },

  update(className, body) {
    return client.put(`/timetable/${className}`, body).then((r) => r.data);
  },

  mySchedule() {
    return client.get("/timetable/my-schedule").then((r) => r.data);
  },
};

export default timetableApi;
